import { configureStore } from '@reduxjs/toolkit';
import aiModelsReducer from './ai-models.slice';
import commonReducer from './common.slice';
import connectorsReducer from './connectors.slice';

export const store = configureStore({
  reducer: {
    aiModels: aiModelsReducer,
    common: commonReducer,
    connectors: connectorsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;